<template>
  <portal to="modal-destination">
    <transition name="fade">
      <main v-if="visible" class="ghana-callback-modal">
        <div class="ghana-callback-modal__overlay" />
        <div class="ghana-callback-modal__content">
          <spinner v-if="loading" :active="true" size="72px" />
          <p v-if="loading" class="ghana-callback-modal__text">{{ $t(signingInKey) }}</p>
          <template v-else-if="errorMessage">
            <p class="ghana-callback-modal__text ghana-callback-modal__text--error">{{ errorMessage }}</p>
            <p v-if="needsPin" class="ghana-callback-modal__hint" v-t.preserve="'auth.ghanaCallback.pinRequired'" />
            <btn flat class="ghana-callback-modal__btn" @click="$emit('dismiss')">{{ $t('auth.ghanaCallback.dismiss') }}</btn>
          </template>
        </div>
      </main>
    </transition>
  </portal>
</template>

<script>
export default {
  name: 'GhanaPhoneCallbackModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    },
    needsPin: {
      type: Boolean,
      default: false
    },
    signingInKey: {
      type: String,
      default: 'auth.ghanaCallback.signingIn'
    }
  }
}
</script>

<style lang="scss" scoped>
.ghana-callback-modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;

  &__overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  &__content {
    z-index: 1;
    position: relative;
    max-width: 90vw;
    min-width: min(320px, 90vw);
    padding: 2rem 1.5rem;
    border-radius: 24px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    box-sizing: border-box;
  }

  &__text {
    margin: 0;
    font-size: 1.1rem;
    text-align: center;
    color: #453d4c;
    line-height: 1.4;

    &--error {
      color: #c0392b;
    }
  }

  &__hint {
    margin: 0;
    font-size: 0.95rem;
    text-align: center;
    color: #606568;
    line-height: 1.35;
  }

  &__btn {
    margin-top: 0.5rem;
  }
}
</style>
